import { CSSProperties, FC, forwardRef, ReactNode, useMemo } from 'react';

import { Icons } from '@beeline/design-tokens/js/iconfont';

import clsx from 'clsx';
import { Parking } from 'src/types';

import { TooltipWrapper } from '../TooltipWrapper/TooltipWrapper';

import { CarIcon } from './CarIcon';
import { Content } from './Content';
import classes from './ParkingPlace.module.scss';

export interface CarPlaceLayoutProps {
  item: Parking;
  containerClassName?: string;
  carClassName?: string;
  contentClassName?: string;
  icon?: Icons;
}

const CarPlaceLayout = forwardRef<HTMLDivElement, CarPlaceLayoutProps>(
  function Inner(
    { item, containerClassName, carClassName, contentClassName, icon },
    ref,
  ) {
    const { width, height, rotation } = item;

    const x = item.x - width / 2;
    const y = item.y - height / 2;

    const containerStyle = useMemo(
      (): CSSProperties => ({
        transform: `translate(${x}px,${y}px)`,
        width: `${width}px`,
        height: `${height}px`,
      }),
      [height, width, x, y],
    );

    const id = item.mapPlaceId;

    return (
      <div style={containerStyle} ref={ref} className={classes.container}>
        <CarIcon
          height={height}
          rotation={rotation}
          containerClassName={clsx(
            classes.enabledContainer,
            containerClassName,
          )}
          carClassName={carClassName}
          placeId={id}
        />
        <Content item={item} contentClassName={contentClassName} icon={icon} />
      </div>
    );
  },
);

export interface CarPlaceProps extends CarPlaceLayoutProps {
  title?: ReactNode;
}

export const CarPlace: FC<CarPlaceProps> = ({ title, ...rest }) => {
  return title ? (
    <TooltipWrapper title={title}>
      <CarPlaceLayout {...rest} />
    </TooltipWrapper>
  ) : (
    <CarPlaceLayout {...rest} />
  );
};
